// Admin → Activation: the My Top Movies acquisition funnel.
// list saved → shared → visitor arrived → visitor built a list → visitor registered.
// Counts are distinct people (user or anonymous visitor) in the selected range.
import { useEffect, useState } from 'react';
import adminApi from '../../services/adminApi';
import styles from './OnboardingInsights.module.css';
import funnelStyles from './ActivationFunnel.module.css';

const pct = (value) => (value == null ? '—' : `${Math.round(value * 100)}%`);

export default function TopMoviesFunnel({ range }) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setError(null);
        adminApi.getTopMoviesFunnel({ range })
            .then((res) => { if (!cancelled) setData(res); })
            .catch((err) => { if (!cancelled) setError(err.message || 'Failed to load Top Movies stats'); });
        return () => { cancelled = true; };
    }, [range]);

    if (error) return <section className={styles.section}><h2 className={styles.sectionTitle}>My Top Movies</h2><p>{error}</p></section>;
    if (!data) return null;
    const max = Math.max(1, ...data.steps.map((s) => s.count));

    return (
        <section className={styles.section}>
            <h2 className={styles.sectionTitle}>My Top Movies — acquisition funnel</h2>
            <table className={funnelStyles.table}>
                <thead>
                    <tr>
                        <th>Step</th>
                        <th className={funnelStyles.num}>People</th>
                        <th className={funnelStyles.num}>Step conv.</th>
                        <th className={funnelStyles.barCol} aria-hidden="true" />
                    </tr>
                </thead>
                <tbody>
                    {data.steps.map((step) => (
                        <tr key={step.key}>
                            <td>{step.label}</td>
                            <td className={funnelStyles.num}>{step.count.toLocaleString()}</td>
                            <td className={funnelStyles.num}>{pct(step.conversionFromPrevious)}</td>
                            <td className={funnelStyles.barCol}><div className={funnelStyles.bar} style={{ width: `${Math.round((step.count / max) * 100)}%` }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <p className={funnelStyles.notes} style={{ marginTop: 12 }}>
                {data.totals.listsCreated} lists saved ({data.totals.publicLists} public) · {data.totals.referredSignups} referred signups,{' '}
                {data.totals.referredSignupsWithList} of whom saved their own list.
            </p>
            <table className={`${funnelStyles.table} ${funnelStyles.compact}`}>
                <thead>
                    <tr><th>Event</th><th className={funnelStyles.num}>Total</th><th className={funnelStyles.num}>Unique</th></tr>
                </thead>
                <tbody>
                    {data.events.map((e) => (
                        <tr key={e.eventType}><td>{e.eventType}</td><td className={funnelStyles.num}>{e.total.toLocaleString()}</td><td className={funnelStyles.num}>{e.uniqueActors.toLocaleString()}</td></tr>
                    ))}
                </tbody>
            </table>
            <ul className={funnelStyles.notes}>
                {data.notes.map((n) => <li key={n}>{n}</li>)}
            </ul>
        </section>
    );
}
